<template>
  <b-modal @hide="modalClose" ref="partnerUserModal" :title="!form.id ? $t('登録') : $t('編集')" size="md">
    <b-container fluid>
      <div class="form-group row">
        <label for="inputEmail3" class="col-sm-4 col-form-label">
          {{ $t('担当者名') }}
          <span class="text-danger">&nbsp;{{ $t("※必須") }}</span>
        </label>
        <div class="col-sm-8">
          <input
            v-model="form.name"
            type="text"
            class="form-control"
            :class="{
              'is-invalid': error.name,
            }"
            placeholder
          />
          <div class="invalid-feedback">{{ error.name }}</div>
        </div>
      </div>
      <div class="form-group row">
        <label for="inputEmail3" class="col-sm-4 col-form-label">
          {{ $t('送り先/手配部署') }}
        </label>
        <div class="col-sm-8">
          <select
            v-model="form.orderingContactId"
            class="form-control"
            id="exampleFormControlSelect1"
            :class="{
              'is-invalid': error.orderingContactId,
            }"
          >
          <div class="invalid-feedback">{{ error.orderingContactId }}</div>
            <template>
              <option value=""></option>
              <option
                v-for="(item, index) in list"
                :key="index"
                :value="item.id"
              >{{ $t(item.name) }}</option>
            </template>
          </select>
        </div>
      </div>
    </b-container>
    <template v-slot:modal-footer>
      <div class="d-flex justify-content-center align-items-center mt-4 mb-4 w-100">
        <button
          type="button"
          class="btn btn-success mr-3 d-flex align-items-center justify-content-center"
          :disabled="registering"
          @click="register()"
        >
          <div
            class="d-flex justify-content-center align-items-center mr-3"
            v-if="registering"
          >
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          </div>
          {{ $t('登録') }}
        </button>
        <button
          type="button"
          class="btn btn-light"
          :disabled="registering"
          @click="modalClose()"
        >{{ $t('キャンセル') }}</button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
const form = {
  partnerId: null,
  name: '',
  orderingContactId: null,
}
export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      form: {},
      error: {},
      registering: false,
    }
  },
  methods: {
    // モーダルを開いたときの処理
    async modalOpen(id = null, partnerId) {
      if (!id) {
        this.form = this.mixin_deepcopy(form)
        this.form.partnerId = partnerId
        this.$refs.partnerUserModal.show()
      } else {
        try {
          const res = await this.$axios.get(
            `${this.$appConfig.CommonApiUrl}/partner/users`,
            {
              headers: {
                Authorization: this.authorization ? this.authorization : null,
              },
              params: { id: id, partnerId: partnerId },
            }
          )
          this.form = res.data[0]
          this.$refs.partnerUserModal.show()
        } catch (err) {
          this.$toasted.show(err)
          this.$emit('modalClose')
        }
        return
      }
    },
    // モーダルを閉じるときの処理
    modalClose() {
      this.$refs.partnerUserModal.hide()
    },
    // 登録処理
    async register() {
      this.error = {}
      try {
        if (!this.form.name) {
          this.error.name = this.$t('担当者名') + this.$t('必須メッセージ')
          return
        }
        this.registering = true
        const method = this.form.id ? 'put' : 'post'
        const params = {}
        if (this.form.id)
          params.id = this.form.id
        params.name = this.form.name
        if (this.form.orderingContactId)
          params.orderingContactId = this.form.orderingContactId
        params.partnerId = this.form.partnerId
        await this.$axios({
          method: method,
          headers: {
            Authorization: this.authorization ? this.authorization : null,
          },
          url: `${this.$appConfig.CommonApiUrl}/partner/user`,
          data: params,
        })
        this.$toasted.success(this.$t('データ登録完了メッセージ'))
        this.$refs.partnerUserModal.hide()
        this.$emit('registed')
      } catch (err) {
        this.$toasted.show(this.$t('データ登録に失敗しました。'))
      }
      this.registering = false
    },
    // 削除処理
    async deleteAlert() {
      const confirm = await this.$swal({
        text: this.$t('削除して本当によろしいでしょうか？'),
        className: 'swal-none',
        buttons: {
          cancel: {
            text: this.$t('キャンセル'),
            value: null,
            visible: true,
            className: '',
            closeModal: true,
          },
          confirm: {
            text: this.$('OK'),
            value: true,
            visible: true,
            className: '',
            closeModal: false,
          },
        },
        dangerMode: true,
      })
      if (!confirm) return
      try {
        await this.$axios.delete(
          `${this.$appConfig.CommonApiUrl}/partner/user`,
          { id: this.form.id, isDelete: true },
          {
            headers: {
              Authorization: this.authorization ? this.authorization : null,
            },
          }
        )
        this.$swal.close()
        this.$toasted.success(this.$t('データ削除完了メッセージ'))
        this.$emit('modalClose')
        this.$refs.partnerUserModal.hide()
      } catch (err) {
        this.$swal.close()
        this.$toasted.show(this.$t('データ削除エラーメッセージ'))
      }
    },
  },
  computed: {
    ...mapGetters({
      authorization: 'auth/authorization',
    }),
  },
}
</script>
